<template>
  <div class="py-6 px-8">
    <h-header>
      <template v-slot:actions>
        <CategoryHeaderActions v-if="isCategoriesRoute" />
        <ItemsHeaderActions v-if="isItemsRoute" />
        <VendorsHeaderActions v-if="isVendorsRoute" />
        <SplitHeaderActions v-if="isSplitConfigurationRoute" />
      </template>
    </h-header>
    <router-view ref="rentOutRouterView" />
  </div>
</template>

<script>
import CategoryHeaderActions from '@/views/category/fragments/CategoryHeaderActions'
import ItemsHeaderActions from '@/views/item/fragments/ItemsHeaderActions'
import VendorsHeaderActions from '@/views/vendor/fragments/VendorsHeaderActions'
import SplitHeaderActions from '@/views/split/fragments/SplitHeaderActions'

export default {
  name: 'RentOut',

  components: {
    CategoryHeaderActions,
    ItemsHeaderActions,
    VendorsHeaderActions,
    SplitHeaderActions,
  },

  computed: {
    isCategoriesRoute() {
      return this.$route.name === 'adminCategories'
    },

    isItemsRoute() {
      return this.$route.name === 'adminItems'
    },

    isVendorsRoute() {
      return this.$route.name === 'adminVendors'
    },

    isSplitConfigurationRoute() {
      return this.$route.name === 'adminSplitConfiguration'
    },
  }
}
</script>
